var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.5 26H12.5L16.5 0H7.5L0.5 26ZM17.5 26H29.5L33.5 0H24.5L17.5 26Z","fill":"black"}));
}

QuoteInline.defaultProps = {"width":"34","height":"26","viewBox":"0 0 34 26","fill":"none"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
